export const BANCOS_MEXICO = [
  'BBVA',
  'Santander',
  'Banamex',
  'Banorte',
  'HSBC',
  'Scotiabank',
  'Inbursa',
  'Banco Azteca',
  'BanCoppel',
  'Banregio',
  'Multiva',
  'Afirme',
  'Banco del Bajío',
  'Mifel',
  'Compartamos Banco',
  'Hey Banco',
  'Nu',
  'Klar',
  'Otro',
] as const;
